import React, { Fragment } from "react";
import WorkListItem from "./WorkListItem";
import IObservation from "../../interfaces/IObservation";
import { useApplicationConfiguration } from "../../configuration/ConfigurationContext";

interface IWorkListContainerProps {
    workList: IObservation[];
}

const WorkListContainer: React.FC<IWorkListContainerProps> = ({ workList }) => {
    const { showUniqueObservationId } = useApplicationConfiguration();
    return (
        <Fragment>
            {workList.map((work) => (
                <WorkListItem key={work.id} item={work} showCreator showId={showUniqueObservationId} />
            ))}
        </Fragment>
    );
};

export default WorkListContainer;
